// global shared items
require('./shared')

require('../site_scripts/mtc_vue_import')

require('./shared_functions')

require('../../../../core/js/plugins/mtc_slick');

require('../site_scripts/mtc_storefront_popup')
require('../site_scripts/mtc_save_car');
require('../site_scripts/mtc_item_card_slider');
require('../site_scripts/mtc_read_more')
require('../site_scripts/mtc_submit_form');
require('../site_scripts/mtc_small_enquiry_form');
require('../site_scripts/mtc_excerpt');

// TODO: When EV Hub redesign starts, refactor all of this. Perhaps create an entry directory similar to other automotive sites so we can see easily find all bundles
require('../ev-hub/tabs')
require('../ev-hub/menu')
